export default __webpack_public_path__ + "static/media/schedule-meeting.bee74728.svg";